import { useCallback, useMemo, Fragment } from 'react';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped file
import withPermissionsTooltip from 'FormsCommonComponents/withPermissionsTooltip';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { DISABLE_TICKET_PROPERTIES, ENABLE_TICKET_PROPERTIES } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import useTicketPropertiesRouting from 'FormsUI/components/hooks/routing/useTicketPropertiesRouting';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionsToggle = withPermissionsTooltip(Toggle);
const PropertyGroupToggle = ({
  ticketToggleEnabled = false,
  hasPermissionsForTickets = false,
  fetchInboxesAndSetInboxId = () => {},
  showDisableTicketWarningDialog = () => {},
  isPaymentsToggleEnabled = false,
  hasFormsATCAccess = false
}) => {
  const {
    isTicketsOrDependentFieldsUsedInRouting,
    removeTicketPropertiesHandler
  } = useTicketPropertiesRouting();
  const ticketToggleOffAndPayments = !ticketToggleEnabled && isPaymentsToggleEnabled;
  const ticketToggleOnAndFieldsUsedInRouting = ticketToggleEnabled && isTicketsOrDependentFieldsUsedInRouting;
  const isTicketToggleDisabled = ticketToggleOffAndPayments || ticketToggleOnAndFieldsUsedInRouting || !hasFormsATCAccess;
  const handlePropertyGroupToggle = useCallback(value => {
    if (value) {
      trackEditorInteraction(ENABLE_TICKET_PROPERTIES);
      fetchInboxesAndSetInboxId();
    } else {
      trackEditorInteraction(DISABLE_TICKET_PROPERTIES);
      showDisableTicketWarningDialog();
      removeTicketPropertiesHandler();
    }
  },
  // eslint-disable-next-line
  [ticketToggleEnabled]);
  const TooltipTitle = useMemo(() => {
    if (isTicketsOrDependentFieldsUsedInRouting) {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'editor.form.properties.ticketProperties.ticketPropertiesUsedInRouting'
        })
      });
    }
    if (isPaymentsToggleEnabled) {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'editor.form.properties.ticketProperties.paymentToggleEnabledTooltipBody'
        })
      });
    }
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.form.properties.ticketProperties.helpdeskToggleTooltipBody'
      })
    });
  }, [isPaymentsToggleEnabled, isTicketsOrDependentFieldsUsedInRouting]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: TooltipTitle,
    disabled: !isTicketToggleDisabled,
    placement: "right",
    children: /*#__PURE__*/_jsx(PermissionsToggle, {
      hasPermission: hasPermissionsForTickets,
      messageKey: 'editor.form.properties.ticketProperties.noPermissions',
      checked: ticketToggleEnabled,
      size: "extra-small",
      onChange: () => handlePropertyGroupToggle(!ticketToggleEnabled),
      disabled: isTicketToggleDisabled,
      "data-test-id": "create-ticket-toggle"
    })
  });
};
export default PropertyGroupToggle;